import { render, staticRenderFns } from "./_ModifyRecycleDisposalReportBasic.vue?vue&type=template&id=513d3032&scoped=true&"
import script from "./_ModifyRecycleDisposalReportBasic.vue?vue&type=script&lang=js&"
export * from "./_ModifyRecycleDisposalReportBasic.vue?vue&type=script&lang=js&"
import style0 from "./_ModifyRecycleDisposalReportBasic.vue?vue&type=style&index=0&id=513d3032&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d3032",
  null
  
)

export default component.exports